/**
 * Codice interno di supporto per le fatture.
 *
 * Perché esiste: quando un cliente scrive al supporto e menziona una fattura,
 * l'admin deve poterla ritrovare rapidamente. Il numero autofattura non è
 * sempre univoco (contatori per anno + sezionale possono ripetersi cambiando
 * azienda cliente), mentre l'UUID interno è troppo lungo da leggere al
 * telefono o incollare in una chat.
 *
 * Formato: `AF-XXXXXX` dove `XXXXXX` sono i primi 6 caratteri esadecimali
 * dell'UUID (uppercase, senza trattini). Sono sufficienti per unicità
 * pratica (~16M combinazioni) e leggibili a colpo d'occhio.
 *
 * IMPORTANTE: questo codice **NON** viene incluso nell'XML FatturaPA né in
 * nessun documento fiscale che il SDI riceve. Serve solo per il tooling
 * interno (support/admin). Deriviamo il codice on-the-fly dall'`invoice.id`,
 * quindi zero migrazioni DB.
 */
export function supportCode(invoiceId) {
  if (!invoiceId) return "";
  return `AF-${String(invoiceId).replace(/-/g, "").slice(0, 6).toUpperCase()}`;
}

/**
 * Ritorna true se `query` corrisponde (case-insensitive) al codice supporto
 * di una fattura. Accetta sia il codice completo (`AF-XXXXXX`) sia solo il
 * suffisso (`XXXXXX`) sia il prefisso dell'UUID (`xxxxxx`).
 */
export function matchesSupportCode(invoiceId, query) {
  if (!invoiceId || !query) return false;
  const q = String(query).trim().toUpperCase().replace(/^AF-/, "");
  if (!q) return false;
  const idHex = String(invoiceId).replace(/-/g, "").toUpperCase();
  return idHex.startsWith(q);
}
